// extracted by mini-css-extract-plugin
export default {"root":"FilterDrawerHeader_root__2UMfv"};